(() => {
  const d = document;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const pad = (n) => String(n).padStart(2, '0');
  const left = (end) => {
    const ms = Date.parse(end) - Date.now();
    if (!(ms > 0)) return null;
    const s = Math.floor(ms / 1000);
    return { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
  };
  // countdowns: [data-mk-countdown="ISO"] with a [data-mk-left] child
  const cds = [...d.querySelectorAll('[data-mk-countdown]')];
  const tick = () => {
    cds.forEach((el) => {
      const t = left(el.dataset.mkCountdown);
      if (!t) { el.hidden = true; return; }
      const out = el.querySelector('[data-mk-left]');
      if (out) out.textContent = `${t.d}d ${pad(t.h)}h ${pad(t.m)}m${el.dataset.mkSeconds ? ` ${pad(t.s)}s` : ''}`;
      el.hidden = false;
    });
  };
  if (cds.length) { tick(); setInterval(tick, 1000); }
  // announcement rotation
  d.querySelectorAll('[data-mk-rotate]').forEach((bar) => {
    const msgs = [...bar.querySelectorAll('.mk-announce-msg')].filter((m) => !m.hidden);
    if (msgs.length < 2 || reduce) return;
    let i = 0;
    setInterval(() => { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 5000);
  });
  // delivery estimate: [data-mk-eta="min,max"]
  const addBiz = (n) => { const x = new Date(); let k = 0; while (k < n) { x.setDate(x.getDate() + 1); const w = x.getDay(); if (w && w < 6) k++; } return x; };
  const fmt = (x) => x.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  const addCal = (n) => { const x = new Date(); x.setDate(x.getDate() + n); return x; };
  const fmtd = (x) => x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  d.querySelectorAll('[data-mk-eta]').forEach((el) => {
    const [a, b] = el.dataset.mkEta.split(',').map(Number);
    const out = el.querySelector('[data-mk-dates]');
    if (out && a && b) out.textContent = 'mkCal' in el.dataset ? `between ${fmtd(addCal(a))} and ${fmtd(addCal(b))}` : `${fmt(addBiz(a))} and ${fmt(addBiz(b))}`;
  });
  // lazy loop videos: <video data-mk-src>
  const vids = [...d.querySelectorAll('video[data-mk-src]')];
  const start = (v) => { if (!v.src) { v.src = v.dataset.mkSrc; v.load(); } const p = v.play(); if (p) p.catch(() => {}); };
  if (!reduce && vids.length) {
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((es) => es.forEach((e) => (e.isIntersecting ? start(e.target) : e.target.src && e.target.pause())), { rootMargin: '200px 0px' });
      vids.forEach((v) => (v.dataset.mkEager ? start(v) : io.observe(v)));
    } else vids.forEach(start);
  }
  // recline diagram
  d.querySelectorAll('[data-mk-recline]').forEach((box) => {
    const back = box.querySelector('.mk-recline-back');
    const legs = box.querySelector('.mk-recline-legs');
    const note = box.querySelector('[data-mk-note]');
    box.querySelectorAll('.mk-chip').forEach((chip) => chip.addEventListener('click', () => {
      box.querySelectorAll('.mk-chip').forEach((c) => { c.classList.toggle('is-on', c === chip); c.setAttribute('aria-pressed', c === chip); });
      const b = Number(chip.dataset.back), l = Number(chip.dataset.legs);
      if (back) back.style.transform = `rotate(${-b}deg)`;
      if (legs) legs.style.transform = `rotate(${-l * 1.4}deg)`;
      if (note) note.innerHTML = `<strong>${chip.textContent.trim()}.</strong> ${chip.dataset.note}`;
    }));
  });
  // copy code buttons
  d.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-mk-copy]');
    if (!btn) return;
    const code = btn.dataset.mkCopy;
    (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(() => { btn.dataset.label = btn.textContent; btn.textContent = 'Copied'; setTimeout(() => (btn.textContent = btn.dataset.label), 1800); }).catch(() => {});
  });
  // sticky add to cart
  const bar = d.querySelector('[data-mk-sticky]');
  const buy = d.querySelector('product-info .product-form__buttons, .product-form__buttons');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => { const past = !e.isIntersecting && e.boundingClientRect.top < 0; bar.classList.toggle('is-on', past); bar.setAttribute('aria-hidden', !past); }).observe(buy);
    bar.querySelector('[data-mk-sticky-add]').addEventListener('click', () => {
      const submit = d.querySelector('product-info .product-form__submit, .product-form__submit');
      if (submit && !submit.disabled) submit.click(); else buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
    const sync = () => {
      const sel = d.querySelector('product-info .product-form__input input:checked');
      const v = bar.querySelector('[data-mk-sticky-variant]');
      if (v && sel) v.textContent = sel.value;
      const pr = d.querySelector('product-info .price .price-item--sale, product-info .price .price-item--regular');
      const tgt = bar.querySelector('[data-mk-sticky-price]');
      if (pr && tgt) tgt.textContent = pr.textContent.trim();
    };
    d.addEventListener('change', (e) => { if (e.target.closest('variant-selects')) setTimeout(sync, 300); });
    sync();
  }
  // price inside the add to cart button follows the selected variant
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (ev) => {
      const sid = ev && ev.data && ev.data.sectionId;
      const html = ev && ev.data && ev.data.html;
      if (!sid || !html || !html.querySelector) return;
      const fresh = html.querySelector(`#ProductSubmitButton-${sid} .mk-atc-price`);
      const cur = d.querySelector(`#ProductSubmitButton-${sid} .mk-atc-price`);
      if (fresh && cur) cur.textContent = fresh.textContent;
      const lp = d.querySelector('.mk-life-price');
      if (fresh && lp) lp.textContent = fresh.textContent;
    });
  }
  // buttons outside the buy box: add the selected variant to the cart
  d.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mk-buy]');
    if (b) {
      const submit = d.querySelector('product-info .product-form__submit, .product-form__submit');
      if (submit && !submit.disabled) submit.click();
      else if (buy) buy.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    // color cards: select the color in the buy box without reloading
    const a = e.target.closest('[data-mk-pick]');
    if (!a) return;
    const input = [...d.querySelectorAll('product-info variant-selects input[type="radio"]')].find((i) => i.value === a.dataset.mkPick);
    if (!input) return;
    e.preventDefault();
    input.click();
    d.querySelectorAll('[data-mk-pick]').forEach((x) => {
      const on = x === a;
      x.classList.toggle('is-on', on);
      if (on) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current');
      const cta = x.querySelector('.mk-color-cta');
      if (cta && (on || cta.textContent.trim() === x.dataset.selected)) cta.textContent = on ? x.dataset.selected : x.dataset.choose;
    });
    const top = d.querySelector('product-info');
    if (top) top.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
  // klaviyo onsite (forms + tracking) when the app embed is not enabled
  window.addEventListener('load', () => {
    if (window._klOnsite || d.querySelector('script[src*="static.klaviyo.com/onsite/js"]')) return;
    const k = d.createElement('script');
    k.async = true;
    k.src = 'https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Rnt45a';
    d.body.appendChild(k);
  });
})();
